import { useLazyQuery, useMutation } from "@apollo/client/react"; import React, { useMemo, useEffect, useState } from 'react';

import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { TextInput } from '../../../components/textInput/TextInput';
import { useDebounce } from '../../../hooks/useDebounce';
import { ButtonOptionGroup } from '../../../components/buttonOptionGroup/ButtonOptionGroup';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { SwitchInput } from '../../../components/switchInput/SwitchInput';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Outlet, useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { adaptPlanCuidadoArray } from '../../../adapters/planCuidadoAdapter';
import { GET_PLANCUIDADO_RENDER_BY_ID } from '../../../data/graphQL/queries/PlanCuidado/getPlanCuidadoById';

import './planCuidadoSearchContent.scss';
import { EDIT_PLANCUIDADO_STATE } from '../../../data/graphQL/mutations/PlanCuidado/editPlanCuidadoState';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { GET_ALL_ESTADO } from '../../../data/graphQL/queries/PlanCuidado/getEstado';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { useLocation } from 'react-router-dom';
import { useGetBreakpoints } from '../../../responsiveTools/breakpoints';
import { CustomChip } from '../../../components/chip/Chip';
import { GET_ALL_PLANES } from '../../../data/graphQL/queries/Planes/getPlanesPaginated';

export const PlanCuidadoSearchContent = ({ setChildrenAction }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isView, setIsView] = useState(false);

  const {
    rows,
    setRows,
    planesLoading,
    totalCount,
    filters,
    handleChangeFilters,
    selectedFilterByStatus
  } = useGetPlanesCuidado();

  const rutasStorage = localStorage.getItem('navigationRoutes');
  const [allowedWrite, setAllowedWrite] = useState(false);

  const ESTADO_VA = "En validacion";
  const ESTADO_IN = "Incompleto";
  const ESTADO_AP = "Aprobado";
  const ESTADO_RE = "Rechazado";

  const getChipEstado = (estado) => {
    switch (estado) {
      case ESTADO_VA:
        return (
          <CustomChip label={estado} isBlue title='Validacion' />);

      case ESTADO_IN:
        return (
          <CustomChip label={estado} isYellow title='Incompleto' />);

      case ESTADO_AP:
        return (
          <CustomChip label={estado} isGreen title='Aprobado' />);

      case ESTADO_RE:
        return (
          <CustomChip label={estado} isRed title='Rechazado' />);

      default: return;
    }
  };

  useEffect(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;

      setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);

    }
  }, [rutasStorage]);

  useEffect(() => {
    if (allowedWrite) {
      setChildrenAction(() =>
        <div>
          <CustomButton
            onClick={() => navigate('/buscarPlan/planCuidado')}>

            Nuevo
          </CustomButton>
        </div>
      );
    }
  }, [setChildrenAction, allowedWrite]);

  const handleClickEditPlanCuidado = async (plan) => {
    setIsView(false);
    await getRenderPlan({
      variables: {
        IdPlanCuidado: plan.id
      }
    });
  };

  const handleView = async (plan) => {
    setIsView(true);
    await getRenderPlan({
      variables: {
        IdPlanCuidado: plan.id
      }
    });
  };

  const handleClickDuplicatePlanCuidado = async (plan) => {
    setIsView(false);
    setIsDuplicate(true);
    await getRenderPlan({
      variables: {
        IdPlanCuidado: plan.id
      }
    });
  };
  
  const [isDuplicate, setIsDuplicate] = useState(false);

  const [getRenderPlan, { loading: renderPlanLoading, data: renderPlan }] = useLazyQuery(GET_PLANCUIDADO_RENDER_BY_ID, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!renderPlan) return;
    renderPlan.planCuidadoToRenderById.insumos = renderPlan.planCuidadoToRenderById?.insumos?.map(obj => {
      const { idInsumoNavigation, ...insumo } = obj
      obj = insumo;
      obj.insumo = { genericDescription: idInsumoNavigation?.descripcion, idInsumo: idInsumoNavigation.idInsumo };
      return obj;
    });

    renderPlan.planCuidadoToRenderById.fases = renderPlan.planCuidadoToRenderById?.fases?.map(obj => {
      obj.planCuidadoFaseCriterio = obj.planCuidadoFaseCriterio.map((criterio) => { return criterio.idCriterio });
      return obj;
    });

    if (isDuplicate) {
      renderPlan.planCuidadoToRenderById.profesionales = renderPlan.planCuidadoToRenderById?.profesionales?.map(obj => {
        obj.idPlanCuidadoFase = renderPlan.planCuidadoToRenderById?.fases?.find(fase => fase.idPlanCuidadoFase == obj.idPlanCuidadoFase)?.idFase;

        return obj;
      });
    }

    navigate('/buscarPlan/planCuidado',
      {
        state: {
          Plan: renderPlan.planCuidadoToRenderById,
          IsDuplicate: isDuplicate,
          AllowedWrite: allowedWrite,
          IsView: isView
        }
      });
  }, [renderPlan]);

  const [getPlanes, { data: planesData }] = useLazyQuery(GET_ALL_PLANES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!planesData) return;
    setRows(planesData);
  }, [planesData])

  const [editPlanCuidado] = useMutation(EDIT_PLANCUIDADO_STATE, {
    refetchQueries: () => {
      getPlanes({
        variables: {
          // We cast the filter value to boolean because Activo: 0 = false, Inactivo: 1 = true
          where: {
            and: [
              selectedFilterByStatus < 2 ? { activo: { eq: !Boolean(selectedFilterByStatus) } } : {}]

          }
        }
      });
    }
  });

  const [estados, setEstados] = useState([]);

  const { isMobile } = useGetBreakpoints();

  const initialColumns = [
    {
      headerName: '',
      field: 'action',
      flex: 0.0247,
      width: 30,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <>
            <PopoverModal>
              <div className='popover-modal-content'>
                {allowedWrite &&
                  <div
                    onClick={() => handleClickEditPlanCuidado(row)} aria-hidden='true'
                    className='item-option clickable-option'>

                    <EditIcon className='edit-icon' />
                    <span className='toggle-action'>Editar</span>
                  </div>
                }
                <div onClick={() => handleView(row)} aria-hidden='true'
                  className='item-option'>

                  <VisibilityIcon className='edit-icon' />
                  <span className='toggle-action'>Ver</span>
                </div>

                {/* {!row.acuerdo && allowedWrite &&
                   <div
                       onClick={() => handleClickDuplicatePlanCuidado(row)} aria-hidden='true'
                       className='item-option clickable-option'
                   >
                       <ContentCopyIcon className='edit-icon' />
                       <span className='toggle-action'>Duplicar</span>
                   </div>
                } */}

                <div className='item-option'>
                  <span className='toggle-action'>Activo</span>
                  <SwitchInput
                    onChange={(e) => {
                      editPlanCuidado({
                        variables: {
                          planCuidadoId: row?.id,
                          status: e.target.checked
                        }
                      });
                      handleChangeFilters('selectedFilterByStatus', e.target.checked ? 1 : 0);
                    }}
                    checked={row?.active} />

                </div>
              </div>
            </PopoverModal>
          </>);

      }
    },
    {
      field: 'id',
      headerName: '#',
      flex: 0.0370,
      width: 40
    },
    {
      field: 'csPlan',
      headerName: 'Cod. Sap',
      flex: 0.1564,
      width: 110
    },
    {
      field: 'name',
      flex: 0.1564,
      width: 240,
      headerName: 'Nombre'
    },
    {
      field: 'tipoModulo',
      flex: 0.1564,
      width: 190,
      headerName: 'Tipo'
    },
    {
      field: 'professional',
      flex: 0.0864,
      width: 100,
      type: 'boolean',
      headerName: 'Profesional',
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'tm',
      type: 'boolean',
      flex: 0.0741,
      width: 80,
      headerName: 'TM',
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'shipment',
      type: 'boolean',
      flex: 0.0741,
      width: 80,
      headerName: 'Envío',
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'active',
      flex: 0.0741,
      width: 80,
      type: 'boolean',
      headerName: 'Activo',
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'acuerdo',
      flex: 0.0741,
      width: 80,
      type: 'boolean',
      headerName: 'Cliente',
      headerAlign: 'center',
      align: 'center'
    },
    {
      field: 'estado',
      flex: 0.0864,
      width: 100,
      headerName: 'Estado',
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return getChipEstado(estados?.find((e) => e.idPlanCuidadoEstado === row?.estado)?.nombre);
      }
    }];


  const columnsParse = initialColumns.map((column) => {
    if (isMobile) {
      const { flex, ...rest } = column;
      return rest;
    } else {
      const { width, ...rest } = column;
      return rest;
    }
  });

  const columns = useMemo(() => generateColumnsDefaultConfiguration(columnsParse, isMobile), [estados, isMobile]);

  const [getEstados, { loading: estadosLoading, data: estadosData }] = useLazyQuery(GET_ALL_ESTADO, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!estadosData) return;
    setEstados(estadosData?.allPlanCuidadoEstado);
  }, [estadosData]);

  useEffect(() => {
    if (!estadosLoading) {
      getEstados();
    }
  }, []);

  return (
    <div className='assistance-program-container'>
      <div className='action-row'>
        <TextInput
          placeholder='Filtrar'
          value={filters?.searchFilter}
          width='30%'
          searchIcon
          onChange={(e) => handleChangeFilters('searchFilter', e.target.value)}
          onClearButtonClick={() => handleChangeFilters('searchFilter', '')} />

        <div className='button-group-container'>
          <ButtonOptionGroup
            options={['Activos', 'Inactivos', 'Todos']}
            onOptionClick={(e) => handleChangeFilters('selectedFilterByStatus', e)}
            selectedOption={filters?.selectedFilterByStatus} />

        </div>
      </div>
      <DataGridGenerico
        columns={columns}
        rows={rows}
        toolbar={false}
        loading={planesLoading}
        totalCount={totalCount} />

    </div>);

};


const useGetPlanesCuidado = () => {

  const [PlanesCuidado, setPlanesCuidado] = useState([]);

  const { filters, handleChangeFilters } = usePersistFilters(
    {
      searchFilter: '',
      selectedFilterByStatus: 0
    },
    'planCuidadoFilters'
  );

  const {
    searchFilter,
    selectedFilterByStatus
  } = filters;

  const debouncedFilterValue = useDebounce(searchFilter, 1000);

  const [getPlanes, { loading: planesLoading, data: planesData }] = useLazyQuery(GET_ALL_PLANES, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (!planesData) return;
    setPlanesCuidado(planesData);
  }, [planesData])

  useEffect(() => {
    if (!planesLoading) {
      getPlanes({
        variables: {
          // We cast the filter value to boolean because Activo: 0 = false, Inactivo: 1 = true
          where: {
            or: [
              { nombre: { contains: debouncedFilterValue?.trim() } },
              { idPlanCuidadoEstadoNavigation: { nombre: { contains: debouncedFilterValue?.trim() } } },
              { idPlanCuidado: { eq: parseInt(debouncedFilterValue?.trim()) || 0 } },
              { codigoSap: { contains: debouncedFilterValue?.trim() } },
              {
                idTipoModuloNavigation: {
                  or: [
                    { abreviacion: { contains: debouncedFilterValue?.trim() } },
                    { descripcion: { contains: debouncedFilterValue?.trim() } }]

                }
              }],


            and: [
              selectedFilterByStatus < 2 ? { activo: { eq: !Boolean(selectedFilterByStatus) } } : {}]

          }
        }
      });
    }
  }, [selectedFilterByStatus, debouncedFilterValue]);

  return {
    rows: adaptPlanCuidadoArray(PlanesCuidado) || [],
    setRows: setPlanesCuidado,
    planesLoading,
    totalCount: PlanesCuidado?.allPlanCuidadoWithoutPaging?.length,
    filters,
    handleChangeFilters,
    selectedFilterByStatus
  };
};